// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState'
import { reducer as getDictionaryReducer } from './getDictionary'
import { reducer as actDeleteDictionaryReducer } from './actDeleteDictionary'
import { reducer as actGetBrandsReducer } from './actGetBrands'
import { reducer as actGetModelsReducer } from './actGetModels'
import { reducer as actPostDictionaryReducer } from './actPostDictionary'
import { reducer as actGetNormalizedWithTermsReducer } from './actGetNormalizedWithTerms'
import { reducer as dictionaryRowDataReducer } from './dictionaryRowData'
import { reducer as actCleanDictionaryStatesReducer } from './actCleanDictionaryStates'
import { reducer as actCreateNormalizedAndTermsReducer } from './actCreateNormalizedAndTerms'
import { reducer as actDeleteVersionDictionaryNormalizedReducer } from './actDeleteVersionDictionaryNormalized'
import { reducer as actGetCommonCategoriesReducer } from './actGetCommonCategories'
import { reducer as actGetYearsReducer } from './actGetYears'
import { reducer as actGetVersionsReducer } from './actGetVersions'
import { reducer as actPostCarSearchReducer } from './actPostCarSearch'
import { reducer as actBatchSearchResultReducer } from './actBatchSearchResult'
import { reducer as actBatchCountReducer } from './actBatchCount'
import { reducer as actGetDictionaryCategoriesReducer } from './actGetDictionaryCategories'
import { reducer as actGetNormalizedTextsReducer } from './actGetNormalizedTexts'
import { reducer as actGetBrandModelNormalizedReducer } from './actGetBrandModelNormalized'
import { reducer as actPostSaveTermReducer } from './actPostSaveTerm'
import { reducer as actBatchFindToCsvReducer } from './actBatchFindToCsv';
import { reducer as actCleanBatchSearchResultReducer } from './actCleanBatchSearchResult';
import { reducer as actClearBatchCountReducer } from './actClearBatchCount';
import { reducer as getCSVMarketPrices } from './getCSVMarketPrices';
import { reducer as getConfigurationsReducer } from './getConfigurations';
import { reducer as updateConfigurationsReducer } from './updateConfigurations';
import { reducer as updateUnsavedChangesReducer } from './updateUnsavedChanges';
import { reducer as actModalConfirmationUsdReducer } from './actModalConfirmationUsdReducer';
 
const reducers = [
  getDictionaryReducer,
  actDeleteDictionaryReducer,
  actGetBrandsReducer,
  actGetModelsReducer,
  actPostDictionaryReducer,
  actGetNormalizedWithTermsReducer,
  dictionaryRowDataReducer,
  actCleanDictionaryStatesReducer,
  actCreateNormalizedAndTermsReducer,
  actDeleteVersionDictionaryNormalizedReducer,
  actGetCommonCategoriesReducer,
  actGetYearsReducer,
  actGetVersionsReducer,
  actPostCarSearchReducer,
  actBatchSearchResultReducer,
  actBatchCountReducer,
  actGetDictionaryCategoriesReducer,
  actGetNormalizedTextsReducer,
  actGetBrandModelNormalizedReducer,
  actPostSaveTermReducer,
  actBatchFindToCsvReducer,
  actCleanBatchSearchResultReducer,
  actClearBatchCountReducer,
  getCSVMarketPrices,
  getConfigurationsReducer,
  updateConfigurationsReducer,
  updateUnsavedChangesReducer,
  actModalConfirmationUsdReducer,
]

export default function reducer(state = initialState, action) {
  let newState
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state
      break
  }
  return reducers.reduce((s, r) => r(s, action), newState)
}
